export function messagesForSession(messages, session, employees = []) {
  if (!session) return [];
  const date = session.date || session.clockIn || session.clockOut;
  if (!date) return [];
  const dateKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  const idsFor = (employee) => [employee.id, employee.employeeId, employee.authUid, employee.uid,
    employee.email?.trim().toLowerCase().replace(/\./g, "_")].filter(Boolean);
  const ids = new Set([session.employeeId, ...(session.schedule?.aliases || [])].filter(Boolean));
  employees.forEach((employee) => {
    const aliases = idsFor(employee);
    if (aliases.some((id) => ids.has(id))) aliases.forEach((id) => ids.add(id));
  });
  return messages.filter((item) => item.date === dateKey &&
    (ids.has(item.employeeId) || ids.has(item.authUid)) &&
    typeof item.message === "string" && item.message.trim());
}
